import { render, staticRenderFns } from "./StatusMessaging.vue?vue&type=template&id=67b1336e"
import script from "./StatusMessaging.vue?vue&type=script&lang=js"
export * from "./StatusMessaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports